import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import apiRequest from "../../functions/api";
import {
  Paper,
  TextField,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  Hidden,
  FormControlLabel,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import BetragInput from "../shared/components/BetragInput";
import Grid from "@mui/material/Grid";
import { useMessage } from "../../context/message-context";
import VisibilityIcon from "@mui/icons-material/Visibility";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import { responsiveFontSizes, useTheme } from "@mui/material/styles";
import openFile from "../shared/functions/download";
import CloseIcon from "@mui/icons-material/Close";
import NewExpense from "./NewExpense";
import ExpenseMobileTable from "./ExpenseMobileTable";
import ExpenseTable from "./ExpenseTable";
import { getFile } from "./getFile";
function Belegerkennung(props) {
  const { t } = useTranslation();
  //Standardfelder
  const { accessToken, client, element, program, ChangeFiles, lock, files, mehrereBelegeErlauben,formular } = props;
  const { showErrorMessage } = useMessage();

  const [isBelegLoading, setIsBelegLoading] = useState(false);
  const [currencies, setCurrencies] = useState([]);
  const [editedIndex, setEditedIndex] = useState(0);
  const [settings, setSettings] = useState({});
  const [artikelOptionen, setArtikelOptionen] = useState([]);
  const [editModus, setEditModus] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedArtikel, setSelectedArtikel] = useState([]);
  const [belege, setBelege] = useState([]);
  const [staaten, setStaaten] = useState([]);
  const [letzteAenderung, setLetzteAenderung] = useState("");
  const [artikelDialog, setArtikelDialog] = useState(false);
  const [fehlerFound, setFehlerFound] = useState(false);
  const [neueAusgabeWerte, setNeueAusgabeWerte] = useState({
    file: "",
    WERTE: {
      BETREFF: "",
      DATUM: "",
      GESAMT: "",
      waehrung: "EURO",
      KURS: "1",
      AUSZAHLUNG: "0",
      ERGEBNIS: "0",
    },
  });
  const controller = useRef(new AbortController());
  const [addExpenseModal, setAddExpenseModal] = useState("");
  useEffect(() => {
    init();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setSettings(element.inhalt);
    if (program === "FORGEN") {
      return;
    } // init()
    let tage = [];

    setBelege(element.felderAntworten ? element.felderAntworten : []);
  }, [element]);

  useEffect(() => {
    if (program === "PMURA3") {
      return;
    }
    updateElement();
  }, [belege]);

  const updateElement = () => {
    let summe = 0;
    let sammelFelder = [];
    belege.forEach((beleg) => {
      summe += parseFloat(beleg.WERTE["AUSZAHLUNG"]);
      sammelFelder.push(beleg);
    });
    element.antwort = summe;
    element.felderAntworten = sammelFelder;
    props.onChange(element.key, element, undefined);
  };

  const init = () => {
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: program,
      statement: "BELEGERKENNUNG_INIT",
      formular:formular,
    };
    apiRequest("POST", "daten", payload, headers, initCB, setRedirect);
  };
  const initCB = (response) => {
    // setAufwendungen(response.data.aufwendungen)
    setStaaten(response.data.staaten);
    setArtikelOptionen(response.data.artikelOptionen);
    setCurrencies(response.data.waehrungen);
  };
  const setRedirect = (path) => {
    navigate(path);
  };

  const apiDataRequest = (payload, headers) => {
    return axios.post(API_BASE_URL + "daten", payload, {
      withCredentials: true,
      headers: headers,
      signal: controller.current.signal,
    });
  };
  
  // function renameFile(file, newName) {
  //   const blob = file.slice(0, file.size, file.type);

  //   const formData = new FormData();
  //   formData.append("file", blob, newName);
  //   return formData;
  // }

  function renameFile2(file, newName) {
    // const test= new File()
    // test.name="abc"
    try {
      return new File(file, newName, {
        type: file.type,
        lastModified: file.lastModified,
      });
    } catch (e) {
      blob.name = newName;
      blob.lastModified = file.lastModified;
      return blob;
    }
  }

  function readFile(event, tmpkey, kz) {
    //     const file = event.target.files[0];
    //     const timeStamp = Date.now();
    //     if (file.name.toUpperCase() === "IMAGE.JPG"||file?.name === "image.jpg") {
    // console.log(renameFile2(file, "image"+files.length+".jpg"))
    //       ChangeFiles(renameFile2(file, "image"+files.length+".jpg"));
    //     } else {
    ChangeFiles(event.target.files[0]);

    setIsBelegLoading(true);
    const payload = {
      program: program,
      statement: "OCR",
      mandant: client,
    };
    const formData = new FormData();
    formData.append("payload", JSON.stringify(payload));
    formData.append("file", event.target.files[0]);
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiDataRequest(formData, headers).then(readFileCB).catch(console.log);

    return () => {
      controller.current.abort();
    };
  }
  const readFileCB = (response) => {
    setIsBelegLoading(false);
    let betreffAlt = neueAusgabeWerte.WERTE.BETREFF;
    let betreffArtikel_KEY = neueAusgabeWerte.WERTE.ARTIKEL_KEY;
    let neuerBeleg = {};
    neuerBeleg.file = files[files.length - 1];
    if (response.status === 200) {
      neuerBeleg["WERTE"] = response.data.WERTE;
      if (!neuerBeleg["WERTE"].ARTIKEL_KEY) {
        neuerBeleg["WERTE"].ARTIKEL_KEY = betreffArtikel_KEY;
      }
      if (!neuerBeleg["WERTE"].BETREFF) {
        neuerBeleg["WERTE"].BETREFF = betreffAlt;
      }
      neuerBeleg["WERTE"].waehrung = "EURO";
      neuerBeleg["WERTE"].KURS = "1";
      neuerBeleg["WERTE"].ERGEBNIS = parseFloat(response.data.WERTE.GESAMT).toFixed(2);
      neuerBeleg["WERTE"].AUSZAHLUNG = parseFloat(response.data.WERTE.GESAMT).toFixed(2);
      neuerBeleg["WERTE"].fileName = files[files.length - 1].name;
      neuerBeleg["WERTE"].artikel = response.data.WERTE.artikel;
      neuerBeleg["WERTE"].fileNumber = files.length;
      response.data.WERTE?.ARTIKEL?.forEach((element, index) => {
        if (!element.ARTIKEL_KEY) {
          neuerBeleg["WERTE"].ARTIKEL[index].ARTIKEL_KEY = betreffArtikel_KEY;
        }
      });
      if (!response.data?.WERTE?.ARTIKEL) {
        neuerBeleg["WERTE"].GESAMT = "0";
        showErrorMessage("Beleg konnte nicht vollständig ausgelesen werden. Bitte tragen Sie die fehlenden Daten manuell ein!");
        setFehlerFound(true);
        addArtikel(0);
      } else if (response.data.auslesenFehler === "1") {
        showErrorMessage("Beleg konnte nicht vollständig ausgelesen werden. Bitte tragen Sie die fehlenden Daten manuell ein!");
        setArtikelDialog(true);
        setFehlerFound(true);
        const index = response.data.WERTE?.ARTIKEL?.length - 1;
        setSelectedArtikel({ ...response.data.WERTE?.ARTIKEL[index], index });
        setLetzteAenderung("BETRAG");
        setEditModus(true);
      }
    } else {
      neuerBeleg["WERTE"] = {};
      neuerBeleg["WERTE"].ARTIKEL_KEY = betreffArtikel_KEY;
      neuerBeleg["WERTE"].ARTIKEL_KEY = betreffAlt;
      neuerBeleg["WERTE"].DATUM = "0000-00-00";
      neuerBeleg["WERTE"].waehrung = "EURO";
      neuerBeleg["WERTE"].KURS = "1";
      neuerBeleg["WERTE"].ERGEBNIS = parseFloat("0").toFixed(2);
      neuerBeleg["WERTE"].AUSZAHLUNG = parseFloat("0").toFixed(2);
      neuerBeleg["WERTE"].fileName = files[files.length - 1].name;
      neuerBeleg["WERTE"].fileNumber = files.length;
      showErrorMessage("Beleg konnte nicht ausgelesen werden. Bitte tragen Sie die Daten manuell ein!");
    }
    setNeueAusgabeWerte(neuerBeleg);
  };

  const cancelLoading = () => {
    let neuerBeleg = {};
    neuerBeleg.file = files[files.length - 1];

    neuerBeleg["WERTE"] = {};
    neuerBeleg["WERTE"].DATUM = "0000-00-00";
    neuerBeleg["WERTE"].waehrung = "EURO";
    neuerBeleg["WERTE"].KURS = "1";
    neuerBeleg["WERTE"].ERGEBNIS = parseFloat("0").toFixed(2);
    neuerBeleg["WERTE"].AUSZAHLUNG = parseFloat("0").toFixed(2);
    neuerBeleg["WERTE"].fileName = files[files.length - 1].name;
    neuerBeleg["WERTE"].fileNumber = files.length;
    showErrorMessage("Belegerkennung wurde abgebrochen. Bitte Werte manuell ausfüllen!");
    setIsBelegLoading(false);
    controller.current.abort();
    setNeueAusgabeWerte(neuerBeleg);
  };
  const neueArtikelBerechnen = () => {
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: program,
      belege: neueAusgabeWerte.WERTE,
      statement: "UPDATE_BELEG",
    };
    apiRequest("POST", "daten", payload, headers, updateCb, setRedirect);
  };
  const updateCb = (response) => {
    let neuerBeleg = {};

    neuerBeleg.file = neueAusgabeWerte.file;
    neuerBeleg.WERTE = response.data.belege;
    if ((neuerBeleg.WERTE.BETREFF === "" || neuerBeleg.WERTE.BETREFF === undefined) && artikelOptionen?.length > 0) {
      neuerBeleg.WERTE.BETREFF = artikelOptionen.find((e) => e.key === neuerBeleg.WERTE.ARTIKEL_KEY).bez;
    }
    setNeueAusgabeWerte(neuerBeleg);
  };

  const addArtikel = (count) => {
    var index = count;
    if (count === 0) {
      setSelectedArtikel({
        Artikelbezeichnung: "",
        NETTO: "0",
        STEUER: "0",
        STEUERSATZ: "0",
        BETRAG: "0",
        index: index + 1,
      });
    } else {
      const letzterArtikel = neueAusgabeWerte?.WERTE?.ARTIKEL[count - 1];
      setSelectedArtikel({
        Artikelbezeichnung: letzterArtikel?.Artikelbezeichnung,
        ARTIKEL_KEY: letzterArtikel?.ARTIKEL_KEY,
        NETTO: "0",
        STEUER: "0",
        STEUERSATZ: "0",
        BETRAG: "0",
        index: index + 1,
      });
    }
    setArtikelDialog(true);
    setSelectedTab(index);
    setEditModus(true);
  };

  const WertChange = (was, wert) => {
    const zwis = neueAusgabeWerte;
    let artikel = zwis.WERTE["ARTIKEL"] ?? [];
    switch (was) {
      case "ARTIKEL_REMOVE":
        zwis.WERTE.ARTIKEL.splice(wert, 1);
        break;
      case "ARTIKEL":
        const index = wert.index;
        if (index > artikel.length) {
          artikel.push(wert);
          zwis.WERTE[was] = artikel;
        } else {
          artikel[index] = wert;
          zwis.WERTE[was] = artikel;
        }
        break;
      case "ARTIKEL_KEY":
        // Finde das passende Artikel-Option-Objekt in der artikelOptionen-Array
        const artikelOption = artikelOptionen.find((e) => e.key === wert);
        if (artikelOption) {
          zwis.WERTE["BETREFF"] = artikelOption.bez;
        }
        zwis.WERTE[was] = wert;

        for (let i = 0; i < artikel.length; i++) {
          //Setze Artikelobjekt wenn das Artikel-Objekt an der aktuellen Position leer ist
          if (artikel[i].ARTIKEL_KEY === "" || !artikel[i].ARTIKEL_KEY) {
            artikel[i].ARTIKEL_KEY = wert;
          }
        }
        zwis.WERTE["ARTIKEL"] = artikel;
        break;
      case "waehrung":
      case "DATUM":
        zwis.WERTE[was] = wert;
        if (was === "waehrung" && wert === "EURO") {
          zwis.WERTE["KURS"] = "1";
        } else {
          getKurs(zwis["WERTE"]["waehrung"], zwis["WERTE"]["DATUM"]);
        }
        break;
      default:
        zwis.WERTE[was] = wert;
        break;
    }
    zwis.WERTE["ERGEBNIS"] = parseFloat(parseFloat(neueAusgabeWerte.WERTE?.["GESAMT"]) / parseFloat(neueAusgabeWerte.WERTE?.["KURS"])).toFixed(2);
    zwis.WERTE["AUSZAHLUNG"] = neueAusgabeWerte.WERTE?.["KREDITKARTE"] === true ? "0,00" : zwis["WERTE"]["ERGEBNIS"];
    setNeueAusgabeWerte({ ...zwis });
  };

  const getKurs = (waehrung, datum) => {
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: program,
      statement: "BELEGERKENNUNG_GET_KURS",
      waehrung: waehrung,
      datum: datum,
    };
    apiRequest("POST", "daten", payload, headers, getKursCb, setRedirect);
  };
  const getKursCb = (response) => {
    WertChange("KURS", response.data.kurs);
  };
  const addExpense = (werte, art) => {
    // if ((werte?.WERTE?.ARTIKEL_KEY === "" || werte?.WERTE?.ARTIKEL_KEY === undefined) && artikelOptionen?.length > 0) {
    //   showErrorMessage("Bitte einen Betreff auswählen");
    //   return;
    // }

    if (isNaN(parseInt(werte.WERTE.GESAMT)) || parseInt(werte.WERTE.GESAMT) === 0) {
      showErrorMessage("Bitte einen Artikel mit Betrag hinzufügen. Gesamtbetrag 0€");
      return;
    }

    if (!werte.WERTE.DATUM || isNaN(Date.parse(werte.WERTE.DATUM))) {
      showErrorMessage("Bitte ein gültiges Datum hinterlegen.");
      return;
    }
    var date = new Date(werte.WERTE.DATUM);
    var twelveMonthsAgo = new Date();
    twelveMonthsAgo.setMonth(twelveMonthsAgo.getMonth() - 12);

    if (date < twelveMonthsAgo) {
      showErrorMessage("Das Datum liegt zu weit in der Verngangenheit.(>12 Monate)");
      return;
    }
    if (!werte.WERTE.DATUM || werte.WERTE.DATUM === "" || werte.WERTE.DATUM === false) {
      showErrorMessage("Bitte ein gültiges Datum hinterlegen.");
      return;
    }

    if (art === "DETAILS") {
      let zwis = belege;
      zwis[editedIndex] = neueAusgabeWerte;
      setBelege([...zwis]);
    } else {
      let zwis = belege;
      zwis.push(werte);
      setBelege([...zwis]);
    }

    setAddExpenseModal("");
    setNeueAusgabeWerte({
      file: "",
      WERTE: {
        BETREFF: "",
        DATUM: "",
        GESAMT: "",
        waehrung: "EURO",
        KURS: "1",
        AUSZAHLUNG: "0",
        ERGEBNIS: "0",
      },
    });
  };
  const removeExpense = (index) => {
    setBelege(belege.filter((e, count) => count !== index));
    updateElement();
  };
  const openBeleg = (beleg, art) => {
    if (art === "datei") {
      openDatei(beleg, art);
      return;
    } else {
      const fileName = beleg.fileName;
      const fileNameWithoutExtension = fileName.split(".")[0];
      getFile(client, accessToken, beleg.fileKey, fileNameWithoutExtension)
        .then((file) => {
          console.log(file.type);
          openFile(file.name, file.content, file.type);
        })
        .catch((err) => {
          showErrorMessage(err);
        })
        .finally(() => {});
    }
  };
  const openDatei = (beleg, art) => {
    const payload = {
      mandant: client,
      program: program,
      art: art,
      fileKey: beleg.fileKey,
      statement: "BELEGERKENNUNG_OPEN_BELEG",
    };
    const data = new FormData();

    data.append("file", beleg.file);

    data.append("payload", JSON.stringify(payload));
    const headers = {
      Authorization: "Bearer " + accessToken,
      Mandant: client,
      program: program,
      statement: "BELEGERKENNUNG_OPEN_BELEG",
    };
    axios
      .post(API_BASE_URL + "upload", data, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        var fileName = beleg.file.name;

        var mimeType = response.headers["content-type"] || "application/pdf";
        var contentFile = response.data;
        openFile(fileName, contentFile, mimeType);
      })
      .catch(function (error) {
        console.log(error);
        //   setSpin(false);
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  };
  const showDetails = (beleg, index) => {
    setEditedIndex(index);
    setAddExpenseModal("DETAILS");
    const zwis = JSON.parse(JSON.stringify(beleg));
    zwis.file = beleg.file;
    setNeueAusgabeWerte(zwis);
  };
  const showBelege = belege.map((beleg, index) => (
    <Grid md={12} item>
      <Paper fullWidth>
        <Grid container spacing={1} paddingBottom={3} fullWidth>
          <>
            <Grid item xs={12} alignItems={"center"} md={3} />
            <Grid item xs={12} alignItems={"center"} md={2}>
              <Button color="secondary" fullWidth onClick={() => removeExpense(index)}>
                {" "}
                <CloseIcon /> Ausgabe entfernen{" "}
              </Button>
            </Grid>
            <Grid item xs={12} alignItems={"center"} md={2}>
              {beleg?.name !== undefined && (
                <Button
                  fullWidth
                  onClick={() => {
                    showDetails(beleg);
                  }}
                >
                  Details anzeigen <InfoIcon spacing={2} />
                </Button>
              )}
            </Grid>
            <Grid item xs={12} alignItems={"center"} md={2}>
              {beleg?.file?.name !== undefined && (
                <Button fullWidth onClick={() => openBeleg(beleg)}>
                  {"Beleg öffnen"} <VisibilityIcon spacing={2} />
                </Button>
              )}
            </Grid>
            <Grid item md={3} />
            <Grid item md={2} />
            <Grid item xs={""} alignItems={"center"} md={2}>
              <TextField
                size="small"
                fullWidth
                onChange={(e) => WertChange(index, "BETREFF", e.target.value, beleg)}
                label={"Betreff"}
                value={beleg.WERTE?.["BETREFF"] ? beleg.WERTE?.["BETREFF"] : ""}
              />
            </Grid>
            <Grid item xs={""} alignItems={"center"} md={1}>
              <TextField
                type="date"
                size="small"
                fullWidth
                onChange={(e) => WertChange(index, "DATUM", e.target.value, beleg)}
                label={"Datum"}
                value={beleg.WERTE?.["DATUM"] ? beleg.WERTE?.["DATUM"] : ""}
              />
            </Grid>

            <Grid item xs={""} alignItems={"center"} md={1}>
              <BetragInput
                size="small"
                disabled={lock}
                fullWidth
                currency={""}
                label={"Gesamtbetrag"}
                value={beleg.WERTE?.["GESAMT"]}
                onChange={(e) => WertChange(index, "GESAMT", e, beleg)}
              />
            </Grid>
            <Grid item xs={""} alignItems={"center"} md={1}>
              <FormControl fullWidth>
                <InputLabel id="">Bezahlt in</InputLabel>

                <Select
                  size="small"
                  fullWidth
                  label="Bezahlt in"
                  // onChange={handleKalenderAnsichtChange}
                  value={beleg.WERTE?.["waehrung"]}
                >
                  <MenuItem value={"EURO"}>{t("Euro")}</MenuItem>
                  {/* <MenuItem value={"M"}>{t("Monatskalender")}</MenuItem>
                  <MenuItem value={"T"}>{t("Tageskalender")}</MenuItem> */}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={""} alignItems={"center"} md={1}>
              <BetragInput
                size="small"
                disabled={lock}
                fullWidth
                currency={"€"}
                label={"Ergebnis in Euro"}
                value={beleg.WERTE?.["ERGEBNIS"] ? beleg.WERTE?.["ERGEBNIS"] : ""}
                onChange={(e) => WertChange(index, "GESAMT", e, beleg)}
              />
            </Grid>
            <Grid item xs={""} alignItems={"center"} md={1}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={beleg.WERTE?.["KREDITKARTE"]}
                    disabled={lock}
                    // onChange={(event) => changeWerte(count, "breakfast", event.target.checked)}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
                labelPlacement=""
                label="Über Kreditkarte gezahlt"
              />
            </Grid>
            <Grid item xs={""} alignItems={"center"} md={1}>
              <BetragInput
                size="small"
                disabled={lock}
                fullWidth
                currency={"€"}
                label={"Auszahlung"}
                value={beleg.WERTE?.["AUSZAHLUNG"] ? beleg.WERTE?.["AUSZAHLUNG"] : ""}
                onChange={(e) => WertChange(index, "GESAMT", e, beleg)}
              />
            </Grid>
            <Grid item md={1}></Grid>
          </>
        </Grid>
      </Paper>
    </Grid>
  ));

  return (
    <>
      <Hidden mdDown>
        <ExpenseTable showDetails={showDetails} expenses={belege} lock={lock} removeExpense={removeExpense} openBeleg={openBeleg} />
        <Grid item xs={12} alignItems={"center"} md={12}>
          {/* {showBelege} */}
          <Button disabled={lock || (!mehrereBelegeErlauben && belege.length === 1)} variant="contained" onClick={() => setAddExpenseModal("neu")}>
            Ausgabe hinzufügen
          </Button>
        </Grid>
      </Hidden>
      <Hidden mdUp>
        <ExpenseMobileTable expenses={belege} removeExpense={removeExpense} openBeleg={openBeleg} showDetails={showDetails} />
        <Grid item xs={12} alignItems={"center"} md={12}>
          {/* {showBelege} */}
          <Button disabled={lock || (!mehrereBelegeErlauben && belege.length === 1)} variant="contained" onClick={() => setAddExpenseModal("neu")}>
            Ausgabe hinzufügen
          </Button>
        </Grid>
      </Hidden>
      <Dialog open={addExpenseModal !== ""} maxWidth="md" fullWidth>
        <DialogContent>
          <NewExpense
            isLoading={isBelegLoading}
            changeValue={WertChange}
            neueArtikelBerechnen={neueArtikelBerechnen}
            lock={lock}
            cancelLoading={cancelLoading}
            data={neueAusgabeWerte}
            addExpenseModal={addExpenseModal}
            readFile={readFile}
            artikelDialog={artikelDialog}
            setArtikelDialog={setArtikelDialog}
            artikelOptionen={artikelOptionen}
            currencies={currencies}
            editModus={editModus}
            setEditModus={setEditModus}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
            settings={settings}
            addArtikel={addArtikel}
            selectedArtikel={selectedArtikel}
            setSelectedArtikel={setSelectedArtikel}
            staaten={staaten}
            letzteAenderung={letzteAenderung}
            setLetzteAenderung={setLetzteAenderung}
            fehlerFound={fehlerFound}
            setFehlerFound={setFehlerFound}
          />
        </DialogContent>
        <DialogActions>
          {" "}
          <Button
            onClick={() => {
              setAddExpenseModal(""),
                setNeueAusgabeWerte({
                  file: "",
                  WERTE: {
                    BETREFF: "",
                    DATUM: "",
                    GESAMT: "0",
                    waehrung: "EURO",
                    KURS: "1",
                    AUSZAHLUNG: "0",
                    ERGEBNIS: "0",
                  },
                });
            }}
          >
            Abbrechen
          </Button>
          <Button variant="contained" color="primary" disabled={lock} onClick={() => addExpense(neueAusgabeWerte, addExpenseModal)}>
            {addExpenseModal === "DETAILS" ? t("Speichern") : t("Hinzufügen")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Belegerkennung;
